import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY, from } from 'rxjs';
import { ClientVendorSearchModel } from 'src/app/classes/client-vendor-search-model';
import { GoogleService } from 'src/app/services/google.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-vendor-search-modal',
  templateUrl: './client-vendor-search-modal.component.html',
  styleUrls: ['./client-vendor-search-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientVendorSearchModalComponent {
  constructor(
    private ActiveModal: NgbActiveModal,
    private GoogleService: GoogleService,
    private ToastService: ToastService
  ) {}

  @Input() companyTypeSearchText!: string;
  @Input() showTradeSelection: boolean = true;

  close() {
    this.ActiveModal.dismiss();
  }

  search(SearchModel: ClientVendorSearchModel) {
    const { address } = SearchModel;

    (() => {
      if (address) {
        const { id } = address;
        if (id) {
          return this.GoogleService.addressDetails({ PlaceId: id });
        }
      }

      return from([EMPTY]);
    })().subscribe({
      next: (AddressDetails) => {
        if (AddressDetails) {
          const { location } = AddressDetails;
          if (location) {
            Object.assign(address, { location });
          }
        }

        this.ActiveModal.close(SearchModel);
      }
    });
  }

  ngOnInit(): void {
    if (!this.companyTypeSearchText) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing company type search text.',
        { returnError: true }
      );
    }
  }
}
